import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, } from '@material-ui/core';
import MSectionHeader from '../../view/MSectionHeader';
import Apis from '../../../network/Apis';
import Swiper from 'react-id-swiper';



class MovieTeamBasketball extends React.Component {

    constructor(props) {
        super(props);
        this.state = { data: [], };
        this.params = {
            slidesPerView: 'auto',
        };
        console.log('MovieTeamBasketball====>', props);
    }


    componentDidMount() {
        this.getBasketballRealtimeData();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getBasketballRealtimeData = async () => {
        let { matchId, matchType } = this.props.match.params; 
        const { data } = this.props;
        if (matchType == 0 && data) {
            matchType = data.match_type;
        }
        if (matchId == 0 && data) {
            matchId = data.match_id;
        }

        let result = await Apis.encryptionDetailLive(matchType, matchId);
        console.log('getBasketballRealtimeData', result);
        if (result.code == 200) {
            console.log(result.data);
            let data = [];
            if (result.data.players && result.data.players.length > 0) {
                let players = result.data.players;
                for (let i = 0; i < players.length && i < 2; i++) {
                    let tmp = [];
                    for (let j = 0; j < players[i].length; j++) {
                        const element = players[i][j];
                        const pdata = element[6].split('^')
                        let obj = {
                            id: element[0],
                            numbers: element[5],
                            name: element[1],
                            start: pdata[16],
                            duration: pdata[0],
                            goal: pdata[13],
                            backboard: pdata[6],
                            assist: pdata[7],
                            shot: pdata[1],
                            threePointer: pdata[2],
                            freeShot: pdata[3],
                            snatch: pdata[8],
                            frontPlate: pdata[4],
                            backPlate: pdata[5],
                            blockShots: pdata[9],
                            miss: pdata[10],
                            foul: pdata[11],
                            jiajian: pdata[12],
                        }
                        tmp.push(obj);
                    }
                    data.push(tmp);
                }
            }
            this.setState({ data: data });
        }
    }

    _readerHeader() {
        const { classes } = this.props;
        return (
            <TableRow style={{ backgroundColor: '#E9F9FF' }}>
                <TableCell align='center' className={classes.tableHead}>号码</TableCell>
                <TableCell align='center' className={classes.tableHead} style={{ minWidth: 100 }}>球员</TableCell>
                <TableCell align='center' className={classes.tableHead}>首发</TableCell>
                <TableCell align='center' className={classes.tableHead}>时间</TableCell>
                <TableCell align='center' className={classes.tableHead}>得分</TableCell>
                <TableCell align='center' className={classes.tableHead}>篮板</TableCell>
                <TableCell align='center' className={classes.tableHead}>助攻</TableCell>
                <TableCell align='center' className={classes.tableHead}>投篮</TableCell>
                <TableCell align='center' className={classes.tableHead}>三分</TableCell>
                <TableCell align='center' className={classes.tableHead}>罚球</TableCell>
                <TableCell align='center' className={classes.tableHead}>抢断</TableCell>
                <TableCell align='center' className={classes.tableHead}>前板</TableCell>
                <TableCell align='center' className={classes.tableHead}>后板</TableCell>
                <TableCell align='center' className={classes.tableHead}>盖帽</TableCell>
                <TableCell align='center' className={classes.tableHead}>失误</TableCell>
                <TableCell align='center' className={classes.tableHead}>犯规</TableCell>
                <TableCell align='center' className={classes.tableHead}>+/-</TableCell>
            </TableRow>
        );
    }

    _renderItem(item, i) {
        const { classes } = this.props;
        return (
            <TableRow key={i} style={{ backgroundColor: i % 2 == 0 ? '#FFF' : '#F9F9F9' }}>
                <TableCell align='center' className={classes.tableBody} style={{ color: '#358BF3' }}>{item.numbers}</TableCell>
                <TableCell align='center' className={classes.tableBody} style={{ minWidth: 100 }}>{item.name}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.start == '0' ? '是' : '否'}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.duration}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.goal}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.backboard}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.assist}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.shot}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.threePointer}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.freeShot}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.snatch}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.frontPlate}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.backPlate}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.blockShots}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.miss}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.foul}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.jiajian}</TableCell>
            </TableRow>
        );
    }

    render() {
        const { classes } = this.props;
        const { data } = this.state;
        let homePlayers = data[0];
        let awayPlayers = data[1];
        const home_name = this.props.data.home_name ? this.props.data.home_name : '';
        const away_name = this.props.data.away_name ? this.props.data.away_name : '';

        return (
            <Grid container direction='column' className={classes.root}>
                <MSectionHeader title={'球员统计-' + home_name} />
                <div style={{ overflowX: 'scroll', width: '100vw' }} >
                    <Table>
                        <TableHead>
                            {
                                this._readerHeader()
                            }
                        </TableHead>
                        <TableBody>
                            {
                                homePlayers && homePlayers.map((item, i) => (
                                    this._renderItem(item, i)
                                ))
                            }
                        </TableBody>
                    </Table>
                </div>
                <MSectionHeader title={'球员统计-' + away_name} />
                <div style={{ overflowX: 'scroll', width: '100vw' }}>
                    <Table>
                        <TableHead>
                            {
                                this._readerHeader()
                            }
                        </TableHead>
                        <TableBody>
                            {
                                awayPlayers && awayPlayers.map((item, i) => (
                                    this._renderItem(item, i)
                                ))
                            }
                        </TableBody>
                    </Table>
                </div>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },
    tableHead: {
        fontSize: 7,
        color: '#898989',
        height: 36,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 2, 0, 2),
        border: 0,
        minWidth: 30,
    },
    tableBody: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(1, 0, 1, 0),
        border: 0,
        height: 24,
        minWidth: 30,
    },

}))(MovieTeamBasketball));